import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from './modules/core/components/dashboard/dashboard.component';
import { LayoutComponent } from './modules/core/components/layout/layout.component';
import { AuthGuard } from '@angular/fire/auth-guard';
import { userLoadedGuard, redirectUnauthorizedToLogin } from './modules/core/guards/guards-functions';
import { SuccesMessageComponent } from '@shared/components/success-message/success-message.component';
import { DocusignCallbackComponent } from '@shared/components/docusign-callback/docusign-callback.component';

const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
      },
      {
        path: 'profile',
        loadChildren: () => import('./modules/profile/profile.module').then(m => m.ProfileModule)
      },
      {
        path: 'dashboard',
        component: DashboardComponent,
        canActivate: [AuthGuard, () => userLoadedGuard()],
        data: { authGuardPipe: redirectUnauthorizedToLogin }
      },
      {
        path: 'payments',
        loadChildren: () => import('./modules/payments/payments.module').then(m => m.PaymentsModule),
        canActivate: [AuthGuard, () => userLoadedGuard()],
        data: { authGuardPipe: redirectUnauthorizedToLogin }
      },
      {
        path: 'policy',
        loadChildren: () => import('./modules/policies/policies.module').then(m => m.PoliciesModule),
        canActivate: [AuthGuard, () => userLoadedGuard()],
        data: { authGuardPipe: redirectUnauthorizedToLogin }
      },
      {
        path: 'quotes',
        loadChildren: () => import('./modules/quotes/quotes.module').then(m => m.QuotesModule),
        canActivate: [AuthGuard, () => userLoadedGuard()],
        data: { authGuardPipe: redirectUnauthorizedToLogin }
      },
      {
        path: 'claims',
        loadChildren: () => import('./modules/claims/claims.module').then(m => m.ClaimsModule),
        canActivate: [AuthGuard, () => userLoadedGuard()],
        data: { authGuardPipe: redirectUnauthorizedToLogin }
      },
      {
        path: 'success-message',
        canActivate: [AuthGuard, () => userLoadedGuard()],
        component: SuccesMessageComponent
      },
      {
        path: 'docusign-callback',
        canActivate: [AuthGuard, () => userLoadedGuard()],
        component: DocusignCallbackComponent
      },
      {
        path: '**',
        redirectTo: 'dashboard'
      }
    ]
  },
  {
    path: '**',
    redirectTo: 'dashboard',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
